export default {
  computed: {

  },
  methods: {
    getFotosPorContrato(idContrato) {
      const actividadesContrato = this.getContratoActividadesTodas
        .filter((a) => (
          a.idContrato === idContrato
              && a.tipo === 2
              && new Date(`${a.fecha} 00:00:0`) >= new Date(`${this.fechaDelInforme} 00:00:0`)
              && new Date(`${a.fecha} 00:00:0`) <= new Date(`${this.fechaAlInforme} 00:00:0`)
        )).map((a) => ({
          contratoNumero: a.contrato.numero,
          descripcion: a.descripcion,
          fecha: a.fecha,
          idFrente: a.frente.id,
          descripcionFrente: a.frente.descripcion,
          ordenFrente: a.frente.orden,
          pieFoto: a.comentarioFotografico,
          conPieFoto: a.comentarioFotografico?.length > 0,
          imagenes: a.imagenes.length > 0 ? a.imagenes : [],
        }))
        .sort((a, b) => a.ordenFrente - b.ordenFrente);

      const frentes = actividadesContrato
        .map(({ descripcionFrente }) => descripcionFrente);
      const actividadesFrentes = frentes.filter((item, index) => frentes.indexOf(item) === index)
        .map((f) => ({
          frente: f,
          detalles: actividadesContrato.filter((a) => a.descripcionFrente === f)
            .map((d, index) => ({ ...d, numero: index + 1 }))
            .sort((a, b) => new Date(`${a.fecha} 00:00:0`) - new Date(`${b.fecha} 00:00:0`)),
        }));

      return actividadesFrentes.map((a) => ({
        frente: a.frente,
        detalles: a.detalles
          .filter(({ imagenes }) => imagenes.length > 0),
      }));
    },
    async generarPdfReporteFotografico() {
      const nombreTemplate = 'templateInformeFotografico';
      const datosContrato = this.formatoObjeto(this.getContrato);

      const datosFecha = this.formatoObjeto({
        fechaDel: this.fechaDelInforme,
        fechaAl: this.fechaAlInforme,
      });
      const fechaTitulo = `del ${datosFecha.fechaDel_texto.slice(0, datosFecha.fechaDel_texto.length - 7)}
          al ${datosFecha.fechaAl_texto}`;
      const logo = this.getCliente?.logo || '';

      const contratosRelacionados = this.getContrato.contratosRelacionados
        .map((c) => c.contratoRelacionado)
        .sort((a, b) => a.orden - b.orden);

      /*
      let actividadesRelacionados = this.getContrato.contratosRelacionados
        .map(({ contratoRelacionado }) => ({
          contratista: contratoRelacionado,
          actividades: this.getFotosPorContrato(contratoRelacionado.id),
        })); */

      let actividadesRelacionados = contratosRelacionados
        .map(({ id }) => ({
          contratista: contratosRelacionados
            .find((contratoRelacionado) => contratoRelacionado.id === id),
          actividades: this.getFotosPorContrato(id),
        }));

      const actividadesContrato = {
        contratista: { numero: this.getContrato.numero },
        actividades: this.getFotosPorContrato(this.getContrato.id),
      };

      const tipoContrato = this.getContrato?.obras[0].obra.tipo.descripcion || '';
      if (tipoContrato === 'OBRA') {
        actividadesRelacionados = [];
      }
      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: false,
            format: 'A3',
            footerTemplate: '',
          },
          nombreTemplate,
        },
        data: {
          contrato: datosContrato,
          tipoContrato,
          actividades: [...actividadesRelacionados],
          actividadesContrato,
          fecha: datosFecha,
          fechaTitulo,
          logo,
          numeroInforme: this.numeroInforme,
          footer: '',
        },
      }, `${this.contrato.numero}_ReporteFotografico_${this.fechaDelInforme}_${this.fechaAlInforme}`);
      this.documentoSeleccionado = null;
    },
  },
};
